export default {
  SET_DOCUMENT_CLASSIFICATIONS: (state, payload) => {
    state.documentClassifications = payload;
  },
  SET_DOCUMENT_CLASSIFICATIONS_LOADING: (state, payload) => {
    state.documentClassificationsLoading = payload;
  },
  SET_DOCUMENT_EXTRACT_TEMPLATES: (state, payload) => {
    state.documentExtractTemplates = payload;
  },
  SET_DOCUMENT_EXTRACT_TEMPLATES_LOADING: (state, payload) => {
    state.documentExtractTemplatesLoading = payload;
  },
};